import { useCallback, useEffect, useRef } from 'react';
import { useParams } from 'quartz-routing/react-router';
import UsageTracker from './utils/UsageTracker';
const ENGAGEMENT_MINUTES = 8;
export const EngagementTracking = () => {
  const {
    lessonId,
    trackId
  } = useParams();
  const lessonIdRef = useRef(lessonId);
  const trackIdRef = useRef(trackId);
  lessonIdRef.current = lessonId;
  trackIdRef.current = trackId;
  const engagementDurationRef = useRef(0);
  const engagementStartTimeRef = useRef(0);
  const intervalRef = useRef(null);
  const hasSubmittedRef = useRef(false);
  const clearTimer = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  const maybeSubmitForm = useCallback(engagementMinutes => {
    if (engagementMinutes > ENGAGEMENT_MINUTES && !hasSubmittedRef.current) {
      hasSubmittedRef.current = true;
      clearTimer();
      if (lessonIdRef.current) {
        UsageTracker.trackStandalone('Learning Center Interaction', {
          action: 'lesson-engagement-timer',
          minutes: ENGAGEMENT_MINUTES,
          lessonId: lessonIdRef.current
        });
      }
      if (trackIdRef.current) {
        UsageTracker.trackStandalone('Learning Center Interaction', {
          action: 'track-engagement-timer',
          minutes: ENGAGEMENT_MINUTES,
          trackId: trackIdRef.current
        });
      }
    }
  }, [clearTimer]);
  const checkEngagement = useCallback(() => {
    const now = new Date().getTime();
    engagementDurationRef.current += now - engagementStartTimeRef.current;
    engagementStartTimeRef.current = now;
    const engagementMinutes = engagementDurationRef.current / 1000 / 60;
    maybeSubmitForm(engagementMinutes);
  }, [maybeSubmitForm]);
  const onFocus = useCallback(() => {
    clearTimer();
    engagementStartTimeRef.current = new Date().getTime();
    intervalRef.current = setInterval(checkEngagement, 30000);
  }, [clearTimer, checkEngagement]);
  const onBlur = useCallback(() => {
    clearTimer();
    checkEngagement();
  }, [clearTimer, checkEngagement]);
  useEffect(() => {
    onFocus();
    window.addEventListener('blur', onBlur);
    window.addEventListener('focus', onFocus);
    return () => {
      onBlur();
      window.removeEventListener('blur', onBlur);
      window.removeEventListener('focus', onFocus);
    };
  }, [onBlur, onFocus]);
  return null;
};